module.exports = __webpack_public_path__ + "img/EndRoute.905b9dad.svg";